export default __webpack_public_path__ + "static/media/sk.031f7d12.svg";